module.exports = {
      id: "comm-finance-usage",
      viewBox: "0 0 245.601 29.882",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#comm-finance",
      toString: function () {
        return this.url;
      }
    }